import script from "./NavigationMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&setup=true&lang=js"

import "./NavigationMenu.vue?vue&type=style&index=0&id=43adb480&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43adb480"]])

export default __exports__